import RegistrationTitle from '../../../features/subscription/components/registrationTitle/RegistrationTitle';

import RegistrationGeographicSectors from '../../../features/subscription/components/registrationGeographicSector/RegistrationGeographicSectors';
import RegistrationProfil from '../../../features/subscription/components/registrationProfil/RegistrationProfil';
import RegistrationSubscribedServices from '../../../features/subscription/components/registrationSubscribedServices/RegistrationSubscribedServices';
import SubscriptionContent from '../../../features/subscription/components/subscriptionContent/SubscriptionContent';
import SubscriptionUpdateButton from '../../../features/subscription/components/SubscriptionUpdateButton';
import useSubscription from '../../../features/subscription/hooks/useSubscription';
import styles from './registrationTab.module.scss';

const RegistrationTab = () => {
  const { subscriptionDemandExists } = useSubscription();
  return (
    <section className={['my-account-content', styles.registration].join(' ')}>
      <RegistrationTitle />

      <div className={styles.content}>
        <div className={styles.section}>
          <div className={styles.sectionSub}>
            <RegistrationProfil />
            <RegistrationSubscribedServices />
          </div>
          <SubscriptionContent />

          <SubscriptionUpdateButton />

          {subscriptionDemandExists && (
            <p className={styles.subscriptionDemandMessage}>
              Une demande de modification d&apos;abonnement est <br />
              en cours de traitement ...
            </p>
          )}
        </div>
        <div className={styles.section}>
          <RegistrationGeographicSectors />
        </div>
      </div>
    </section>
  );
};

export default RegistrationTab;
